import { render, staticRenderFns } from "./LoadingChartContainer.vue?vue&type=template&id=606aba24&scoped=true&"
import script from "./LoadingChartContainer.vue?vue&type=script&lang=js&"
export * from "./LoadingChartContainer.vue?vue&type=script&lang=js&"
import style0 from "./LoadingChartContainer.vue?vue&type=style&index=0&id=606aba24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606aba24",
  null
  
)

export default component.exports